import { useEffect, useState } from "react";
import toast from "../../utils/toast";
import { postsApi } from "../../services";
import "./accCredHistory.css";

function formatChangedAt(date) {
  if (!date) return "—";
  return new Date(date).toLocaleString("vi-VN", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

// Lịch sử đổi user/pass đăng nhập acc (GET /posts/:id/creds-history) — dùng để
// truy lại khi sửa nhầm. Hai chỗ dùng:
//   - Modal sửa acc: collapsible + onRestore (điền lại giá trị cũ vào form).
//   - Tab "Lịch sử user/pass" ở trang chi tiết acc: mở sẵn, chỉ xem.
// Payload có mật khẩu → chỉ gọi API khi panel thực sự mở.
export default function AccCredHistory({ postId, collapsible = false, onRestore }) {
  const [open, setOpen] = useState(!collapsible);
  const [items, setItems] = useState(null); // null = chưa tải
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !postId) return;
    let alive = true;
    setLoading(true);
    postsApi
      .getCredentialsHistory(postId)
      .then((data) => { if (alive) setItems(data || []); })
      .catch(() => {
        if (!alive) return;
        toast.error("Không tải được lịch sử user/pass");
        if (collapsible) setOpen(false);
      })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, postId]);

  return (
    <div className={`acc-hist${collapsible ? " acc-hist-collapsible" : ""}`}>
      {collapsible && (
        <button type="button" className="acc-hist-toggle" onClick={() => setOpen(!open)}>
          <i className={`fas fa-chevron-${open ? "down" : "right"}`}></i>
          <i className="fas fa-history"></i>
          Lịch sử đổi user/pass
          {items !== null && <span className="acc-hist-count">{items.length}</span>}
        </button>
      )}

      {open && (
        loading ? (
          <div className="acc-hist-empty">Đang tải...</div>
        ) : !items || items.length === 0 ? (
          <div className="acc-hist-empty">Chưa có lần đổi user/pass nào được ghi lại.</div>
        ) : (
          <ul className="acc-hist-list">
            {items.map((h, i) => (
              <li key={i} className="acc-hist-item">
                <div className="acc-hist-meta">
                  <span className="acc-hist-time">{formatChangedAt(h.changedAt)}</span>
                  {h.changedBy && <span className="acc-hist-by">bởi {h.changedBy}</span>}
                  {onRestore && (
                    <button
                      type="button"
                      className="acc-hist-restore"
                      title="Điền lại user/pass trước lần đổi này"
                      onClick={() => onRestore(h)}
                    >
                      <i className="fas fa-undo"></i> Dùng lại bản cũ
                    </button>
                  )}
                </div>
                {h.prevUsername !== h.newUsername && (
                  <div className="acc-hist-diff">
                    <span className="acc-hist-label">user</span>
                    <code className="acc-hist-old">{h.prevUsername || "(trống)"}</code>
                    <i className="fas fa-arrow-right"></i>
                    <code className="acc-hist-new">{h.newUsername || "(trống)"}</code>
                  </div>
                )}
                {h.prevPassword !== h.newPassword && (
                  <div className="acc-hist-diff">
                    <span className="acc-hist-label">pass</span>
                    <code className="acc-hist-old">{h.prevPassword || "(trống)"}</code>
                    <i className="fas fa-arrow-right"></i>
                    <code className="acc-hist-new">{h.newPassword || "(trống)"}</code>
                  </div>
                )}
              </li>
            ))}
          </ul>
        )
      )}
    </div>
  );
}
